<h1 class="strong" mat-dialog-title>{{ confirmationDialogData.title | translate }}</h1>
<div mat-dialog-content>
  <p>{{ confirmationDialogData.desc | translate }}</p>
</div>
<div mat-dialog-actions>
  <button class="btn btn-secondary" (click)="closeDialog(false)" data-testid="confirmation-dialog-cancel-button">
    {{ 'shared.cancel' | translate }}
  </button>
  @if (confirmationDialogData.saveBtnText) {
    <button class="btn btn-primary" (click)="closeDialog('save')">
      {{ confirmationDialogData.saveBtnText | translate }}
    </button>
  }
  <button
    class="btn btn-primary"
    [class.warning]="confirmationDialogData.isWarning"
    (click)="closeDialog(true)"
    data-testid="confirmation-dialog-confirm-button"
  >
    {{ confirmationDialogData.confirmationBtnText | translate }}
  </button>
</div>
